import {ConjugationViewProps} from "../../../components/ConjugationView";
import {JapaneseVerb} from "../types";

export function useJapaneseConjugation({word}: ConjugationViewProps) {

    if (!word.morphology) {
        return {
            hasConjugationInfo: false,
            posWithTagging: word.partOfSpeech,
        }
    }

    const verbTagger = () => {
        const info: JapaneseVerb = word.morphology as JapaneseVerb;
        return info.class === "godan" ? "Godan verb" :
            info.class === "ichidan" ? "Ichidan verb":
            info.class === "suru" ? "くる verb" :
            "する verb"
    };

    const otherTagger = () => word.partOfSpeech;

    const posWithTagging = word.partOfSpeech === "Verb" ? verbTagger() : otherTagger();

    return {
        hasConjugationInfo: word?.partOfSpeech === "Verb",
        posWithTagging
    }

}